import React, { useContext, useEffect, useState } from "react";
import { PortalContext } from "../../../context/Provider";
import DatePicker from "../../Genericos/DatePicker/DatePicker";
import HeaderModal from "../../Genericos/headerModal/headerModal";
import "./FiltrosTurnos.css";
import CheckBoxGroupFilter from "_+_Portal/components/Genericos/CheckBoxGroupFilter/CheckBoxGroupFilter";
import {
  FiltrosTurnosBtnBox,
  FiltrosTurnosContainer,
  FlechaContainer,
  ItemBox,
  Line,
  TituloLineBox,
} from "./localstyle";
import IconBlack from "_+_Portal/assets/images/generico/IconBack";

const FiltrosTurnos2 = ({
  titulo,
  dissmiss,
  handleClickBuscar,
  handleClickProximos,
  handleChangeDatePicker,
  flgExcedeBusq,
  fecha,
  filtros,
  filtrosData,
  setFiltrosAplicados,
  handleChangeCentros,
  handleChangeDia,
  handleChangeRango,
  handleChangeEspecialista,
  setShowFiltros,
  checkboxData,
  setCheckboxData,
}) => {
  const { turnosDisponiblesState } = useContext(PortalContext);
  const [showItem, setShowItem] = useState({
    centro: checkboxData?.centros.some((item) => item.checked),
    fecha: true,
    dia: checkboxData?.diasKin.some((item) => item.checked),
    horario: checkboxData?.rangoHorario.some((item) => item.checked),
    especialista: checkboxData?.especialistas.some((item) => item.checked),
  });

  const fechaLimte = new Date();
  const days = 90;
  fechaLimte.setDate(fechaLimte.getDate() + days);

  // Esto es para el datePicker
  const noventaDiasDespues = new Date(fecha);
  noventaDiasDespues.setDate(noventaDiasDespues.getDate() + 90);
  const diaSelecionado =
    turnosDisponiblesState.turnosDisponibles.turnosData.fechaSeleccionada;

  const onChangeItemShow = (e, item) => {
    setShowItem({
      ...showItem,
      [e]: !item,
    });
  };

  const handleChangeCheckbox = (categoria, updatedData) => {
    setCheckboxData((prev) => ({ ...prev, [categoria]: updatedData }));
    const filtrosSeleccionados = updatedData.filter((item) => item.checked);
    setFiltrosAplicados((prev) => [
      ...prev.filter(
        (f) => !updatedData.some((u) => u.descripcion === f.descripcion)
      ),
      ...filtrosSeleccionados,
    ]);
    if (categoria === "diasKin") {
      handleChangeDia(updatedData);
    } else if (categoria === "rangoHorario") {
      handleChangeRango(updatedData);
    } else if (categoria === "centros") {
      handleChangeCentros(updatedData);
    } else if (categoria === "especialistas") {
      handleChangeEspecialista(updatedData);
    }
    setShowFiltros(true);
  };

  useEffect(() => {
    setCheckboxData({
      centros:
        turnosDisponiblesState.turnosDisponibles.turnosData.volverOrigen ===
          "LABORATORIO"
          ? filtrosData?.centrosLabo.filter(
            (item) => item.descripcion !== "Todos los centros"
          ) || []
          : filtrosData?.centros.filter(
            (item) => item.descripcion !== "Todos los centros"
          ) || [],
      diasKin:
        filtrosData?.diasKin.filter((item) => item.descripcion !== "Todos") ||
        [],
      rangoHorario:
        filtrosData?.rangoHorario.filter(
          (item) => item.descripcion !== "Todos"
        ) || [],
      especialistas: (
        filtrosData?.especialistas.filter(
          (item) => item.descripcion !== "Todos"
        ) || []
      ).sort((a, b) => a.descripcion.localeCompare(b.descripcion)),
    });
  }, [filtros]);

  return (
    <React.Fragment>
      <HeaderModal titulo={titulo} dissmiss={dissmiss} />
      <FiltrosTurnosContainer>
        <TituloLineBox>
          <ItemBox>
            <div className="title-arrow-box">
              <p className="rb18m">Fecha</p>
            </div>
            <div
              className={`content ${showItem.fecha ? "visible" : "hidden"}`} style={{ width: "100%" }}
            >
              <div className="datepickerBox">
                <DatePicker
                  fechaInicial={`${fecha.getFullYear()} ${fecha.getMonth() + 1
                    } ${fecha.getDate()}`}
                  selectedFecha={`${!diaSelecionado ? "" : diaSelecionado}`}
                  fechaFinal={`${fechaLimte.getFullYear()} ${fechaLimte.getMonth() + 1
                    } ${fechaLimte.getDate()}`}
                  onChange={handleChangeDatePicker}
                  customCss={"ptur-headerBarFiltros-filtros-datePicker"}
                />
              </div></div>
          </ItemBox>
          <Line />
        </TituloLineBox>
        <TituloLineBox>
          <ItemBox onClick={() => onChangeItemShow("centro", showItem.centro)}>
            <div className="title-arrow-box">
              <p className="rb18m">Centros</p>
              <FlechaContainer
                $rotate={showItem.centro ? 1 : 0}
              >
                <IconBlack color={"var(--color-latex30)"} size={8} />
              </FlechaContainer>
            </div>
            <div
              className={`content ${showItem.centro ? "visible" : "hidden"}`}
            >
              <CheckBoxGroupFilter
                data={checkboxData?.centros}
                onChange={(data) => handleChangeCheckbox("centros", data)}
              />
            </div>
          </ItemBox>
          <Line />
        </TituloLineBox>

        <TituloLineBox>
          <ItemBox onClick={() => onChangeItemShow("dia", showItem.dia)}>
            <div className="title-arrow-box">
              <p className="rb18m">Día</p>
              <FlechaContainer
                $rotate={showItem.dia ? 1 : 0}
              >
                <IconBlack color={"var(--color-latex30)"} size={8} />
              </FlechaContainer>
            </div>
            <div className={`content ${showItem.dia ? "visible" : "hidden"}`}>
              <CheckBoxGroupFilter
                data={checkboxData?.diasKin}
                onChange={(data) => handleChangeCheckbox("diasKin", data)}
              />
            </div>
          </ItemBox>
          <Line />
        </TituloLineBox>

        <TituloLineBox>
          <ItemBox onClick={() => onChangeItemShow("horario", showItem.horario)}>
            <div className="title-arrow-box">
              <p className="rb18m">Horarios</p>
              <FlechaContainer
                $rotate={showItem.horario ? 1 : 0}
              >
                <IconBlack color={"var(--color-latex30)"} size={8} />
              </FlechaContainer>
            </div>
            <div
              className={`content ${showItem.horario ? "visible" : "hidden"}`}
            >
              <CheckBoxGroupFilter
                data={checkboxData?.rangoHorario}
                onChange={(data) => handleChangeCheckbox("rangoHorario", data)}
              />
            </div>
          </ItemBox>
          <Line />
        </TituloLineBox>

        <TituloLineBox>
          <ItemBox onClick={() => onChangeItemShow("especialista", showItem.especialista)}>
            <div className="title-arrow-box">
              <p className="rb18m">Especialistas</p>
              <FlechaContainer
                $rotate={showItem.especialista ? 1 : 0}
              >
                <IconBlack color={"var(--color-latex30)"} size={8} />
              </FlechaContainer>
            </div>
            <div
              className={`content ${showItem.especialista ? "visible" : "hidden"
                }`}
            >
              <CheckBoxGroupFilter
                data={checkboxData?.especialistas}
                onChange={(data) => handleChangeCheckbox("especialistas", data)}
              />
            </div>
          </ItemBox>
          <Line />
        </TituloLineBox>
      </FiltrosTurnosContainer>
      <FiltrosTurnosBtnBox>
        <button
          className="ptur-filtrosTurnos-btnBuscar c-white rb18m"
          onClick={handleClickBuscar}
        >
          Aplicar filtros
        </button>

        <div className="ptur-filtrosTurnos-divsores-box">
          <div className="ptur-filtrosTurnos-divsor"></div>
          <span className="ptur-filtrosTurnos-divsores-txt rb12m">
            o
          </span>
          <div className="ptur-filtrosTurnos-divsor"></div>
        </div>

        <button
          className="ptur-filtrosTurnos-btnProx c-latex30 rb16m"
          onClick={handleClickProximos}
        >
          {!flgExcedeBusq
            ? "Filtrar próximos turnos disponibles"
            : "Reiniciar búsqueda"}
        </button>
      </FiltrosTurnosBtnBox>
    </React.Fragment >
  );
};

export default FiltrosTurnos2;
